<template>
  <div v-if="items" class="gp-content">
    <table-tile-bar :view.sync="view" :refresh="refresh">
      <p class="level-item is-size-4 bar-title">Profiles</p>
      <pagination
        class="level-item"
        :next="hasNext"
        :prev="hasPrev"
        :nextClick="nextPage"
        :prevClick="prevPage"
        :page="page"
        :perPage="perPage"
        :itemCount="itemCount"
        :total="total"
        :loading="loading">
      </pagination>
      <router-link class="button add level-item" :to="{ name: 'profiles.index.create' }">
        <i class="fas fa-plus"></i>
        Create Profile
      </router-link>
    </table-tile-bar>
    <div class="scroll-vertical">
      <profiles-table
        v-if="view === 'table'"
        :profiles="items"
        :sortDirection="sortDirection"
        :sortField="sortField"
        :onSort="onSort"></profiles-table>
      <profiles-tiles v-else :profiles="items"></profiles-tiles>
    </div>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination';
import ProfilesTable from '@/components/profiles/ProfilesTable.vue';
import ProfilesTiles from '@/components/profiles/ProfilesTiles.vue';
import TableTileBar from '@/components/TableTileBar.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Profiles',
  mixins: [pagination],
  components: {
    ProfilesTable,
    TableTileBar,
    ProfilesTiles,
    Pagination,
  },
  data() {
    return {
      endpoint: 'primary/listProfiles',
      sortDirection: 'DESC',
      sortField: 'created',
    };
  },
  computed: {
    view: {
      set(value) { this.$store.commit('actionViewState/SET_VIEW', value); },
      get() { return this.$store.state.actionViewState.view; },
    },
    requestVars() {
      return {
        direction: this.sortDirection,
        field: this.sortField,
      };
    },
  },
  async mounted() {
    this.refresh(null);
  },
  methods: {
    onSort(field, order) {
      this.sortDirection = order.toUpperCase();
      this.sortField = field;
      this.reset();
    },
  },
};
</script>
